import { useEffect, useState } from "react";
import { PersonDTO } from "../../../../database/people/dto";
import { PrivacyComponent } from "../../../../database/people/privacy";
import { ContactStateEnum } from "../../../dto";
import { NotConfirm } from "./notConfirm";
import { PrivacyVerified } from "./privacyVerified";
import { NotVerifiedStep1 } from "./step1";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    listIndex: number;
    isLoading: boolean
    handleConfirm: (outcome: ContactStateEnum, outcomeInfo: string | null) => void;
    person: PersonDTO
}

export function LeadTakenPrivacyNotVerified({ isOpen, onClose, listIndex, isLoading, handleConfirm, person }: Props) {
    const [step, setStep] = useState(1);

    useEffect(() => {
        if (!isOpen)
            setStep(1);
    }, [isOpen])

    const pages: Record<number, JSX.Element> = {
        1: <NotVerifiedStep1 setStep={setStep} isOpen={isOpen} person={person} />,
        2: <NotConfirm setStep={setStep} listIndex={listIndex} isLoading={isLoading} handleConfirm={handleConfirm} person={person} />,
        3: <PrivacyComponent personId={''} setLeadStep={setStep} section={"outcome"} person={person} privacy={person?.privacy ?? false} />,
        4: <PrivacyVerified onClose={() => onClose()} listIndex={listIndex} isLoading={isLoading} handleConfirm={handleConfirm} />
    };

    return (pages[step] || (<div></div>))
}